import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(true, {

    [actions.HIDE_LEGAL_DIALOG]: (state, action) => false

})



// WEBPACK FOOTER //
// ./src/reducers/legalDialog.js